const state = {
   deviationFixerQueue:{},
}

export default state
